import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'trg-price',
    templateUrl: './price.component.html',
    styleUrl: 'price.component.scss',
    standalone: true,
    imports: [NgClass],
})
export class PriceComponent {
    private _price: number;
    mainPrice: string;
    centimePrice: string;

    @Input() hasPeriod: boolean = false;
    @Input() isMainPrice: boolean = false;
    @Input() isSecondaryPrice: boolean = false;
    @Input() isAdditionalPrice: boolean = false;
    @Input() asterix: string;
    @Input() hasIcon: boolean = false;
    @Input() iconClassNames: string = 'tri-icon tri-infos-circle has-text-primary';
    @Input() isDiscountPrice: boolean = false;
    @Input() isWithoutTax: boolean = false;
    @Input() isInlined: boolean = false;
    @Input() size: string;
    @Input() inheritFontSize: boolean = false;
    @Input() isBold: boolean;

    @Output('clickIcon') clickIconEvent: EventEmitter<boolean> = new EventEmitter(true);

    @Input() set price(price: number) {
        this._price = price;
        const priceFormatted: string[] = this.splitPrice(this._price);
        this.mainPrice = priceFormatted[0];
        this.centimePrice = priceFormatted[1] !== '00' ? priceFormatted[1] : '';
    }

    private splitPrice(price: number): string[] {
        price = this.excludeTax(price);
        return parseFloat(price.toString()).toFixed(2).split('.');
    }

    clickIcon() {
        this.clickIconEvent.emit(true);
    }

    private excludeTax(value: number): number {
        if (this.isWithoutTax) {
            value = this.round(value);
            return this.round(value / 1.2);
        }
        return value;
    }

    private round(value: number): number {
        return Number((Math.round(Number((value * Math.pow(10, 2)).toFixed(1))) / Math.pow(10, 2)).toFixed(2));
    }
}
